import './index.less';

const { ont } = window.utils;

const renderTradeRulesRow = (data) => {
  return `
    <tr>
        <td class="column column0-wrapper">${data.currency_pair}</td>
        <td class="column">${data.precision}</td>
        <td class="column">${data.quote_increment}</td>
        <td class="column">${data.min_trade_size}</td>
        <td class="column" width="16%">${data.max_trade_size}</td>
        <td class="column" width="16%">${data.trade_limit}</td>
    </tr>
  `;
};

const renderSellRulesRow = (data) => {
  return `
    <tr>
        <td class="column column0-wrapper">${data.currency_pair}</td>
        <td class="column">${data.precision}</td>
        <td class="column">${data.min_trade_size}</td>
        <td class="column">${data.max_trade_size}</td>
        <td class="column" width="16%">${data.trade_limit}</td>
    </tr>
  `;
};

window.addEventListener('DOMContentLoaded', async () => {
  const currenciesRes = await ont.get('/v2/asset/introduction/currencies');
  const { data: currencyList } = currenciesRes.data;

  const currencyListContent = currencyList
    .map((item) => {
      return item.currency;
    })
    .join('、');
  document.getElementById('rulesCurrencyList').innerHTML = currencyListContent;

  const tradeRulesRes = await ont.get('/v2/asset/introduction/tradingRules');
  const { data: tradeRules } = tradeRulesRes.data;

  const tradeJpyPairList = tradeRules
    .filter((item) => {
      return item.currency_pair.includes('/JPY');
    })
    .map((item) => {
      return item.currency_pair;
    })
    .join('、');
  document.getElementById('rulesJpyPairList').innerHTML = tradeJpyPairList;

  const tradeBtcPairList = tradeRules
    .filter((item) => {
      return item.currency_pair.includes('/BTC');
    })
    .map((item) => {
      return item.currency_pair;
    })
    .join('、');
  document.getElementById('rulesBtcPairList').innerHTML = tradeBtcPairList;

  const tradeRulesContent = tradeRules
    .map((item) => {
      return renderTradeRulesRow(item);
    })
    .join('');
  document.getElementById('rulesTableBody').innerHTML = tradeRulesContent;

  const sellRulesRes = await ont.get('/v2/asset/introduction/sellingRules');
  const { data: sellRules } = sellRulesRes.data;

  const sellPairList = sellRules
    .map((item) => {
      return item.currency_pair;
    })
    .join('、');
  document.getElementById('rulesSellPairList').innerHTML = sellPairList;

  const sellRulesContent = sellRules
    .map((item) => {
      return renderSellRulesRow(item);
    })
    .join('');
  document.getElementById('rulesSellTableBody').innerHTML = sellRulesContent;
});
